import type { Flights, Fare } from "@b2bportal/air-shopping-api";
import type { ISelectedTrip, IFlightListData } from "@b2bportal/core-types";
import { filterLowestFares } from "./fare";

export const getReturnFlights = (
  flights: Flights,
  returnTripIds: string[],
  selectedTrip: ISelectedTrip
) => {
  const selectedOutgoingFare = selectedTrip.outgoingFareId
    ? flights.fares[selectedTrip.outgoingFareId]
    : null;
  const selectedOutgoingFareSlice = selectedOutgoingFare
    ? flights.fareSlices[selectedOutgoingFare.outbound]
    : null;

  const selectedOutgoingFareSliceId = selectedOutgoingFareSlice?.id;

  return returnTripIds.reduce(
    (returnFlightList: IFlightListData<Fare>[], tripId: string) => {
      const trip = flights.trips[tripId];
      const returnSliceId = flights.trips[tripId].return || "";

      const tripFares = trip.fares.map(
        (fareId: string) => flights.fares[fareId]
      );

      // Logic for filtering return flights
      const getFilteredFares = () => {
        return tripFares.filter((tripFare) => {
          if (!tripFare.return) return true;

          const returnFareSlice = flights.fareSlices[tripFare.return];
          const outgoingFareSlice = flights.fareSlices[tripFare.outbound];

          // if the fare has the selected outgoing FARE SLICE, the return fare slice must be valid (even though the fare classes are different - Hacker fare)
          if (
            selectedOutgoingFareSliceId &&
            tripFare.outbound === selectedOutgoingFareSliceId
          ) {
            return true;
            // even if the fare doesn't have the selected outgoing fare slice, only admit it
            // as an upsell: the outbound must move to a STRICTLY higher shelf, never the
            // same shelf (same-shelf fares can be different, cheaper brands) or lower
          } else if (
            selectedTrip.outgoingFareRating !== null &&
            selectedTrip.outgoingFareRating !== undefined
          ) {
            return (
              returnFareSlice.fareShelf.value >=
                selectedTrip.outgoingFareRating &&
              outgoingFareSlice.fareShelf.value >
                selectedTrip.outgoingFareRating
            );
          } else {
            return false;
          }
        });
      };

      const filteredTripFares = getFilteredFares();

      const pricingMode =
        "priceBreakdown" in selectedOutgoingFare ? "fixed" : "flex";

      if (filteredTripFares.length > 0) {
        const fares =
          pricingMode === "fixed"
            ? filterLowestFares(filteredTripFares, flights)
            : filteredTripFares;
        returnFlightList.push({
          sliceId: returnSliceId,
          fares,
        });
      }

      return returnFlightList;
    },
    []
  );
};
